/*eslint-disable*/ export const messages = {
    Apply: "Anwenden",
    Clear: "Clear",
    "Date picker open, choose a date": "Datumsauswahl geöffnet, Datum auswählen",
    "Date range picker open, select a date range": "Datumsauswahl geöffnet, Datumsbereich auswählen",
    "End Date": "Enddatum",
    "Please enter a date ({format})": ["Geben Sie ein Datum ein (", ["format"], ")"],
    "Please select a date after {minDate}": ["Bitte wählen Sie ein Datum aus nach dem ", ["minDate"]],
    "Please select a date before {maxDate}": ["Bitte wählen Sie ein Datum aus vor dem ", ["maxDate"]],
    "Show next month": "Nächsten Monat anzeigen",
    "Show previous month": "Vorherigen Monat anzeigen",
    "Start Date": "Startdatum",
    "The selected date is disabled": "Das ausgewählte Datum ist deaktiviert",
    "The selected date is unavailable. Please select another.":
        "Das ausgewählte Datum ist nicht verfügbar. Bitte wählen Sie ein anderes.",
    Today: "Today",
    "Today, {dateStr}": ["Heute, ", ["dateStr"]],
    "date picker": "Datumsauswahl",
    "start date selected": "Startdatum ausgewählt",
    to: "to",
    "{dateStr}, select end date": [["dateStr"], ", Enddatum auswählen"],
    "{dateStr}, select start date": [["dateStr"], ", Startdatum auswählen"],
    "{startDate} to {endDate}, choose apply to confirm, or cancel": [
        ["startDate"],
        " bis ",
        ["endDate"],
        ", Anwenden zum Bestätigen auswählen oder abbrechen",
    ],
};
